module.exports = __webpack_public_path__ + "static/media/logo-mercadopago.023f32ef.png";